import { useMediaQuery } from '@ag1/ui';
import type { EmblaOptionsType } from 'embla-carousel';
import useEmblaCarousel from 'embla-carousel-react';
import { useEffect, useMemo } from 'react';

type Options = {
  itemsLength: number | undefined;
};

export function useReviewsSlider({ itemsLength }: Options) {
  const atMedium = useMediaQuery('m');

  const activateSlider = !!(itemsLength && itemsLength > 1);
  const direction = useMemo(() => (atMedium ? 'y' : 'x'), [atMedium]);

  const options: EmblaOptionsType = useMemo(
    () => ({
      active: activateSlider,
      axis: direction,
      align: 'start',
      duration: 45,
      loop: true
    }),
    [activateSlider, direction]
  );

  const [emblaRef, emblaApi] = useEmblaCarousel(options);

  const autoplayInterval = 4000;

  useEffect(() => {
    if (!emblaApi) return;

    emblaApi.reInit(options);

    const autoplay = setInterval(() => {
      emblaApi.scrollNext();
    }, autoplayInterval);

    // eslint-disable-next-line consistent-return
    return () => {
      clearInterval(autoplay);
    };
  }, [emblaApi, options, itemsLength]);

  return {
    ref: emblaRef
  };
}
